import { EventBus } from "@/event-bus";
import { AccountManagement } from "@/interfaces/accountManagement";
import { i18n } from "@/plugins/i18n";
import accountServices from "@/services/account.services";
import {
  TableActiveSubComponent,
  TableFieldType,
  TableHeader
} from "helix-vue-components";

interface TableDefs {
  headers: TableHeader[];
  data: any[];
  rowActions: any[];
  subcomponent: TableActiveSubComponent;
}
export const AccountManagementTable: TableDefs = {
  headers: [
    {
      label: String(i18n.t("account_management_module.table.date")),
      value: "date",
      fieldComponent: TableFieldType.fnsDate
    },
    {
      label: String(i18n.t("account_management_module.table.due_date")),
      value: "due_date",
      fieldComponent: TableFieldType.fnsDate
    },
    {
      label: String(i18n.t("account_management_module.table.status")),
      value: "status",
      fieldComponent: TableFieldType.string
    },
    {
      label: String(i18n.t("account_management_module.table.method")),
      value: "payment_method",
      fieldComponent: TableFieldType.string
    },
    {
      label: String(i18n.t("account_management_module.table.taxes_and_fees")),
      value: "taxes_and_fees",
      fieldComponent: TableFieldType.currency
    },
    {
      label: String(i18n.t("account_management_module.table.amount")),
      value: "amount",
      fieldComponent: TableFieldType.currency
    }
  ],
  data: [],
  rowActions: [
    {
      icon: "fal fa-dollar-sign",
      componentName: "TableButtonComponent",
      class: "account-management__table--action",
      visibleCondition: (item: AccountManagement.BillingInvoice) =>
        item.status === AccountManagement.BILL_STATUS.PENDING,
      action: (invoice: AccountManagement.BillingInvoice) => {
        EventBus.$emit("payInvoice", invoice);
      }
    },
    {
      icon: "fal fa-file-download",
      componentName: "TableButtonComponent",
      class: "account-management__table--action",
      action: (invoice: AccountManagement.BillingInvoice) => {
        accountServices.downloadReceipt(invoice.id);
      }
    }
  ],
  subcomponent: {
    position: null,
    component: "BillingBreakdownSubTable",
    field: "summary"
  }
};

export const creditCardDefault: AccountManagement.CreditCard = {
  id: 0,
  nickname: "",
  card_number: "",
  card_type: "",
  cvv: "",
  holder_name: "",
  expiration_month: "",
  expiration_year: "",
  identification_nro: "",
  identification_type: "",
  address: "",
  city: null,
  country_id: null,
  state: null,
  postcode: "",
  default: 0
};
